import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../../services-http/notification/notification.service';


@Component({
  selector: 'app-notification-popover',
  templateUrl: './notification-popover.component.html',
  styleUrls: ['./notification-popover.component.scss']
})
export class NotificationPopoverComponent implements OnInit, OnDestroy {

  user: any = null;

  @Input() close!: () => void;
  @Output() unreadCountChanged = new EventEmitter<number>();
  notifList: any = [];

  private notifSub: Subscription = null;


  constructor(
    public notification: NotificationService
  ) { }

  ngOnInit() {
    try {
      const raw = localStorage.getItem('currentUser');
      this.user = raw ? JSON.parse(raw) : null;
    } catch (e) {
      this.user = null;
    }
    this.getnotif();
    this.listenRealtime();
  }

  ngOnDestroy() {
    if (this.notifSub && !this.notifSub.closed) {
      this.notifSub.unsubscribe();
      this.notifSub = null;
    }
  }

  /** Subscribe to realtime websocket notifications so the badge updates live. */
  listenRealtime() {
    const notifStream: any = this.notification && this.notification.realtime && (this.notification.realtime as any).notifications$;
    if (notifStream && typeof notifStream.subscribe === 'function') {
      this.notifSub = notifStream.subscribe((msg: any) => {
        if (!msg) { return; }
        const loginId = msg && (msg.loginId || msg.login_id || msg.user_id);
        const isBroadcast = msg.broadcast === 1 || msg.broadcast === true;
        const isForUser = this.user && (loginId === this.user.iloginId || isBroadcast);
        if (isForUser) {
          this.notifList.unshift(msg);
          this.unreadCountChanged.emit(this.notifList.filter((n: any) => n.status !== 1).length);
        }
      });
    }
  }

  notificationRead(notification: any) {
    if (!notification || !notification.notification_id) { return; }
    this.notification.notificationRead(notification.notification_id)
      .subscribe({
        next: (res: any) => {
          notification.status = 1;
          this.notifList = this.notifList.filter((n: any) => n.notification_id !== notification.notification_id);
          this.unreadCountChanged.emit(this.notifList.filter((n: any) => n.status !== 1).length);
        },
        error: (err: any) => {
          console.warn('[NOTIF] notificationRead failed:', err);
        },
      });
  }

  getnotif() {
    if (!this.user || !this.user.iloginId) {
      console.warn('[NOTIF] cannot fetch notifications: no currentUser.iloginId');
      return;
    }
    this.notification.getNotification(this.user.iloginId)
      .subscribe({
        next: (res: any) => {
          this.notifList = Array.isArray(res) ? res : [];
          this.unreadCountChanged.emit(this.notifList.filter((n: any) => n.status !== 1).length);
        },
        error: (err: any) => {
          console.warn('[NOTIF] getNotification failed:', err);
          this.notifList = [];
        },
      });
  }
}
